import { render, staticRenderFns } from "./memberAdd.vue?vue&type=template&id=381a351a&scoped=true"
import script from "./memberAdd.vue?vue&type=script&lang=js"
export * from "./memberAdd.vue?vue&type=script&lang=js"
import style0 from "./memberAdd.vue?vue&type=style&index=0&id=381a351a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a351a",
  null
  
)

export default component.exports